import React from 'react';
import fr from 'facet-rest';
import useUserContext from 'Context/UserContext';
import ClientExperienceSavesPage from './ClientExperienceSavesPage';
import { SaveProvider } from './ClientExperienceSavesContext';


const ClientExperienceSavesWithProvider = () => {
  const { agentResource } = useUserContext();
  const link = agentResource?.relationship(
    fr.relationships.escalatedHousehold.name,
  ).link('related');
  return (
    <SaveProvider link={link}>
      <ClientExperienceSavesPage />
    </SaveProvider>
  );
};


export default ClientExperienceSavesWithProvider;
